"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locationContentFragment = void 0;
exports.locationContentFragment = `
fragment locationContent on LocationContent {
  lat
  long
}
`;
//# sourceMappingURL=location-content.js.map